import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scrollElementRef"];
import { forwardRef, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function getCoreComponent(Component) {
  let node = Component;
  while (node.WrappedComponent) {
    node = node.WrappedComponent;
  }
  return node;
}
export function attachWrappedComponent(Decorator, WrapperComponent) {
  Decorator.WrappedComponent = WrapperComponent;
  Decorator.CoreComponent = getCoreComponent(WrapperComponent);
}
export function ShareScrollElement(Component) {
  const ShareScrollElementComponent = /*#__PURE__*/forwardRef((props, ref) => {
    const {
        scrollElementRef
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, rest, {
      scrollElementRef: scrollElementRef || defaultRef,
      ref: ref
    }));
  });
  attachWrappedComponent(ShareScrollElementComponent, Component);
  return ShareScrollElementComponent;
}